// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_e5637090 _cda9498a","title":"_6e5fc743","projectLink":"_b7331f6","tagIcon":"_e4f1c13a","tagTextWrapper":"_238b041f","tagText":"_686ff92c"};